






























import { Component, Vue } from 'vue-property-decorator'

import HeaderBar from '@/components/HeaderBar'

import { Household } from '@/datastore/models'

import auth from '@/store/modules/auth'
import grocery from '@/store/modules/grocery'

import HouseholdCard from './components/HouseholdCard.vue'

@Component({
	components: {
		HeaderBar,
		HouseholdCard,
	},
})
export default class AccountPage extends Vue {

	get households(): Household[] {

		return grocery.households
	}

	get user(): firebase.UserInfo | null {

		return auth.user
	}

}

